module.exports = __webpack_public_path__ + "producr-dried fresh-grass-16.jpg?30d81197d25a26cd7bc91484c3bb097d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-16.jpg
// module id = 74
// module chunks = 0